import ApplicationModel, { attr } from '../ApplicationModel';
import { type WorkflowKindTemplateAttributes } from './generated/WorkflowKindTemplateAttributes';
import { model } from '../modelBuilder';

interface WorkflowKindTemplate extends WorkflowKindTemplateAttributes {}

@model
class WorkflowKindTemplate extends ApplicationModel {
  // Start auto-generated
  static typename: 'WorkflowKindTemplate' = 'WorkflowKindTemplate';
  get typename(): 'WorkflowKindTemplate' {
    return 'WorkflowKindTemplate';
  }

  static internalTypename: 'WorkflowKindTemplate' = 'WorkflowKindTemplate';
  get internalTypename(): 'WorkflowKindTemplate' {
    return 'WorkflowKindTemplate';
  }

  static fields = {
    body: attr({ readable: true }),
    id: attr({ readable: true }),
  };
  // End auto-generated
}

export default WorkflowKindTemplate;
